import { useEffectOnce } from 'react-use'

import { loginRedirectUrl } from '~/configs/app'
import useAuth from '~/hooks/useAuth'
import ErrorLayout from '~/layouts/ErrorLayout'
import type { PageRouteProps } from '~/types/route'

import ExternalRedirect from '../common/ExternalRedirect'
import PageLoading from '../common/PageLoading'

const PrivateRoute = ({ children }: PageRouteProps) => {
  const { isAuthenticated, isLoading, checkAuthentication } = useAuth()

  useEffectOnce(() => {
    checkAuthentication()
  })

  if (isLoading) {
    return (
      <ErrorLayout>
        <PageLoading>Memeriksa sesi login...</PageLoading>
      </ErrorLayout>
    )
  }

  if (!isAuthenticated) {
    return <ExternalRedirect to={loginRedirectUrl} />
  }

  return <>{children}</>
}

export default PrivateRoute
